import React from 'react';
import PropTypes from 'prop-types';

const rootStyles = {
  height: 18,
  width: 18,
  cursor: 'pointer',
};

function ProjectionMobDot({ active, index, onClick = () => {} }) {
  return (
    <div
      className={`paginationSwipe${active ? ' active' : ''}`}
      style={rootStyles}
      onClick={(e) => onClick(e, index)}
    >
      <div
        style={{
          backgroundColor: active ? 'white' : 'lightgrey',
          height: 6,
          width: 6,
          borderRadius: 999,
          margin: 3,
        }}
      />
    </div>
  );
}

ProjectionMobDot.propTypes = {
  active: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export { ProjectionMobDot };
